function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 23.5,
  fill: "#03070E",
  stroke: "#36383F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.7612 22.8685L33.7803 22.8984V22.8997L33.7987 22.9283L33.8006 22.9315L33.8159 22.9589C33.8872 23.0836 33.9375 23.2148 33.9668 23.3478C34.04 23.71 33.9954 24.0518 33.8013 24.3745C33.7605 24.5196 33.4245 24.8003 33.287 24.8818L20.2513 32.1144C20.0228 32.2411 19.765 32.3092 19.5009 32.3092C19.0763 32.1997 18.9624 32.3124 18.5391 31.9718C18.4029 31.8604 18.2909 31.7363 18.2011 31.5867L18.1992 31.5835L18.182 31.5543V31.553L18.1642 31.5218L18.1623 31.5174C18.0586 31.3219 18 31.1004 18 30.8668V16.4417C18 16.1922 18.0662 15.9573 18.184 15.7524C18.3214 15.5213 18.4844 15.3482 18.7237 15.2094C18.9516 15.0783 19.2062 15.0051 19.4716 15C19.7587 15.0006 20.0025 15.0522 20.2539 15.1922L33.2532 22.4045C33.4652 22.5222 33.6358 22.6833 33.7612 22.8691",
  stroke: "white",
  strokeWidth: 1.6
});

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.0c859ef78e1879178f5b03efc5b57c8c9e8cffead92e3f42b2d2dd967ba943f1.svg";
export { ForwardRef as ReactComponent };